<ion-modal class="modalCustom modalBig" #mdlFirma (ionModalDidDismiss)="mdlFirma.isOpen = false">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="mdlFirma.dismiss()"><ion-icon name="close"></ion-icon></ion-button>
        </ion-buttons>
        <ion-title>Firmar</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
     <div class="p-3 p-lg-4">
      <div class="boxInfo"><ion-icon name="document-text-outline" class="icon"></ion-icon>{{disclaimer}}</div>
      <div>
        <fv-canvas-drawing new-image-background="transparent" #canvasDrawing [allow-clear-image]="true" [background-image]="backgroundImage" [width]="width" [height]="height" [hide-colors]="true"></fv-canvas-drawing>
      </div>
     </div>
    </ion-content>
    <ion-footer>
      <ion-buttons slot="end" class="ml-auto">
        <ion-button class="btn1 ml-auto" (click)="guardarFirma()"><ion-icon name="save" class="mr-2"></ion-icon>Guardar firma</ion-button>
      </ion-buttons>
    </ion-footer>
  </ng-template>
</ion-modal>
